export const progressColors = {
  black: '#232526',
  green: '#52C41A',
  orange: '#FAAD14',
  yellow: '#FAAD14',
  red: '#F5222D',
  blue: '#42B0D5',
  empty: '#E4E8ED',
  white:'#fff'
};

export const processState = {
  IN_PROGRESS: 'IN PROGRESS',
  COMPLETED: 'FINISHED',
  WAITING: 'NOT STARTED',
  EMPTY: 'EMPTY',
  WAITING_CONTAINER: 'UNKNOWN',
};

export const labelsByVariant = {
  '': {
    emptyDescription: 'Waiting for next equipment to dock',
    waitingInfoTitle: 'Waiting for equipment information',
    waitingStartTitle: 'Waiting to start',
    waitingStartDescription: '', // intentionally left empty
    completeTitle: 'Process Complete',
    completeDescription: 'Waiting for equipment to undock',
    storageTitle: 'Storage',
    storageDescription: 'Equipment in storage',
  },
  'v2': {
    emptyDescription: 'Waiting for next equipment to dock',
    waitingInfoTitle: 'Waiting for equipment information',
    waitingStartTitle: 'Waiting to start',
    waitingStartDescription: '', // intentionally left empty
    completeTitle: 'Process Complete',
    completeDescription: 'Waiting for equipment to undock',
    storageTitle: 'Storage',
    storageDescription: 'Equipment in storage',
  }
}